
export default {
  referrals:{
    97: '0x23cF3FB108c8A541560be9f4ab628336FD43DE61',
    56: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
    0xfa2:'0x03607B27C7123A58aB78B295bF16fe1826F63F29'
  },
  masterChef: {
    97: '0x1d32c2945C8FDCBc7156c553B7cEa4325a17f4f9',
    56: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
    0xfa2:'0x49E4d031e79aB8C88E3A6e90d511c2fcF4914De2'
    // 0xfa2: '0xaB4Ea59EE4d6B318EeF0fBA0f968AFcA77f0fda2',
  },
  sousChef: {
    97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    56: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
    0xfa2: '0xe09801aad77560A3C437556661dd028E25ebbdc3'
  },
  lottery: {
    97: '0x99c2EcD51d52c036B00130d882Bc65f20Fdecf9f',
    56: '0x3C3f2049cc17C136a604bE23cF7E42745edf3b91',
    0xfa2: '0x2EAe8FaeddDb6644d832514D61CD195bB7E5B7C7'
  },
  lotteryNFT: {
    97: '0x8175c10383511b3a1C68f9dB222dc14A19CC950e',
    56: '0x5e74094Cd416f55179DBd0E45b1a8ED030e396A1',
    0xfa2: '0xF4DAEa31F8D73a56D0d9C24B2001fafE2753389a'
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x67ADCB4dF3931b0C5Da724058ADC2174a9844412',
    0xfa2: '0x3192cbc358aE9395C0E11fc4EA7C82242202a874'
  },
  pancakeProfile: {
    56: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    97: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
    0xfa2:  '0xc9595c312b0EFAdc8dfc7A5e5E2cE075B00AF298'
  },
  pancakeRabbits: {
    56: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
    0xfa2:  '0x7ce2f94C1Bd46171c02A9E645bf574c466c516dC'
  },
  bunnyFactory: {
    56: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
    0xfa2:  '0x2b0d9E8C7312D253fBA8a61680F1087265d8a329'
  },
  claimRefund: {
    56: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    97: '0x24522A6E3d8Fb6A096174eBfbDc41215335D0c2b',
    0xfa2:  '0x24522A6E3d8Fb6A096174eBfbDc41215335D0c2b'
  },
  pointCenterIfo: {
    56: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
    0xfa2:  '0x7bD908CD7194AE1407099165245291AE11eDc41f'
  },
  bunnySpecial: {
    56: '0xFee8A195570a18461146F401d6033f5ab3380849',
    97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
    0xfa2:  '0xb3b2B8de193B67c8854eb48990fe11B5f8Eb2206'
  },
}
